import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const EnergySavingContainer = styled.div<{ theme: { token: GlobalToken } }>`
  position: relative;

  h1 {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
  }

  .highcharts-container {
    display: inline-grid;
    grid-template-columns: repeat(2, auto);
    grid-column-gap: 40px;
    margin: ${({ theme: { token } }) => token.marginMD}px 0 0;
    position: relative;

    .legend-container {
      display: flex;
      align-items: center;
    }
  }

  .spinner {
    width: 250px;
    height: 270px;
  }

  .highcharts-chart-data > div > svg {
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px !important;
  }

  .skeleton-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: ${({ theme: { token } }) => token.marginXXL}px;
    gap: ${({ theme: { token } }) => token.marginXXL}px;

    .energy-savings-skeleton {
      margin-right: ${({ theme: { token } }) => token.marginXXL}px;
    }

    .legend-container {
      display: flex;
      flex-direction: column;
      gap: ${({ theme: { token } }) => token.marginXXL}px;
    }
  }
`;

export const LifetimeSavingsContainer = styled.div<{ theme: { token: GlobalToken } }>`
  border-radius: 2px;
  display: flex;
  align-items: center;
  height: 40px;
  width: 100%;
  font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
  justify-content: center;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  position: absolute;
  left: 0;
  bottom: 38px;
  padding: 0 ${({ theme: { token } }) => token.paddingXS}px;

  .lifetime-savings-skeleton {
    width: fit-content;
  }

  .lifetime-label {
    &.title {
      height: 18px;
      margin: ${({ theme: { token } }) => token.marginXS}px ${({ theme: { token } }) => token.margin}px 0 0;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      white-space: nowrap;
    }

    &.percentage {
      margin: ${({ theme: { token } }) => token.marginXXS}px ${({ theme: { token } }) => token.marginXXS}px 0 0;
      font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme: { token } }) => token.colorText};
    }

    &.power {
      height: 18px;
      margin: ${({ theme: { token } }) => token.marginSM}px 0 ${({ theme: { token } }) => token.marginXXS}px
        ${({ theme: { token } }) => token.marginXXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
    }

    .saving-chip {
      background-color: ${({ theme: { token } }) => token.colorSuccess};
    }

    &.legend-item-chip {
      margin-left: ${({ theme: { token } }) => token.margin}px;
      margin-right: ${({ theme: { token } }) => token.marginXS}px;
    }

    &.flex-container {
      display: flex;
      align-items: center;
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
    }
  }
`;
